import { Button, Stack, Typography } from '@mui/material';
import type React from 'react';
import { useHasWriteAccess, useIsValidatedBayerUserType } from '/@/hooks/session';
import { _ } from '/@/locale';
import ModalV2 from '../bayer/modal-v2';

interface FieldviewLoginPopupProps {
    handleClose: () => void;
    message: string;
}

const FieldviewLoginPopup: React.FC<FieldviewLoginPopupProps> = ({ handleClose, message }) => {
    const hasWriteAccess = useHasWriteAccess();
    const isUserValidated = useIsValidatedBayerUserType();
    return (
        <ModalV2
            open={hasWriteAccess}
            onClose={handleClose}
            title={message}
            actions={
                <Button variant='contained' color='secondary' onClick={handleClose}>
                    {_('Cerrar')}
                </Button>
            }
            actionsProps={{
                justifyContent: 'flex-end',
            }}
        >
            <Stack direction='column' spacing={2} alignItems='center'>
                <Typography variant='body1' color='primary'>
                    {isUserValidated
                        ? _(
                              'Los lotes de tu operación se están importando y estarán disponibles en la sección "Mis lotes". Este proceso puede tardar unos minutos.'
                          )
                        : _(
                              'Los lotes de tu operación se están importando y estarán disponibles. Este proceso puede tardar unos minutos.'
                          )}
                </Typography>
            </Stack>
        </ModalV2>
    );
};

export default FieldviewLoginPopup;
